import type { VoidFunctionComponent } from 'react';

import styles from './StateContextPanel.module.less';

const LoadingPanel: VoidFunctionComponent = () => {
  return (
    <div className={styles.stateContextPanel}>
      Loading data...
    </div>
  );
};

export default LoadingPanel;
